import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-chat-portal',
  templateUrl: './chat-portal.component.html',
  styleUrls: ['./chat-portal.component.css']
})
export class ChatPortalComponent implements OnInit {
  urlSafe: SafeResourceUrl;
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    var pas=localStorage.getItem("LogAutPas")
    var em=localStorage.getItem("LogAutUs")
    var js={
      "userEmail":em,
      "passUser":pas,
      "plataforma":"WAREHOUSE"
   };
   var encodedString = btoa(JSON.stringify(js));
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
     'https://messenger.3plapp.com/login?enckey='+encodeURIComponent(encodedString)
    );
  }

}
